export default __webpack_public_path__ + "static/media/main_bg.559c488b.svg";